import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PannesMachine } from 'src/app/model/incidents/pannesList.model';
import { IncidentsSuivi, IncidentSuivi } from 'src/app/model/incidents/pannesSuivi.model';
import { IncidentsService } from 'src/app/services/http/incidents/incidents.service';
import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';


@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss']
})

@Injectable ({ providedIn: 'root' })

export class IncidentsComponent implements OnInit {

  get displayedColumn(): string[] {
    const result: string[] = ['numSerie', 'nomInstallation', 'suiviMotif', 'suiviJoursRestants', 'rgCount', 'erCount', 'anomalies'];
    return result;
  }

  constructor(private service: IncidentsService, private router : Router) { }
  public incidents !: IncidentsSuivi;
  public pannes !: PannesMachine;
  public btnClicked : boolean = false;
  public sortDirection: boolean = false;
  public sortedData !: IncidentSuivi[] ;

  ngOnInit(): void {
    this.service.getIncidentsSuiviData()
    .subscribe( (incidents) => {
        // console.log(incidents); 
        this.incidents = incidents;
        this.sortedData = incidents.installations.slice();
  });
  }


  /**
   * GET the details of one machine pannes
   */
  public getOneMachinePannesData( id : number ) : any {
    this.service.getPannesMachineData( id.toString() ).subscribe((pannes)=>{
      this.pannes = pannes;
      // console.log(pannes);
      this.router.navigate(['incidents-pannes', id]);
      this.btnClicked = true;

    })
  }

    sortData(sort : Sort){
      const data = this.incidents.installations.slice();
      if (!sort.active || sort.direction === '') {
        this.sortedData = data;
        return;
      }

      this.sortedData = data.sort((a, b) => {
        const isAsc = sort.direction === 'asc';
        switch (sort.active) {
          case 'numero_serie':
            return this.compare(a.numero_serie, b.numero_serie, isAsc);
          case 'nom_installation':
            return this.compare(a.nom_installation, b.nom_installation, isAsc);
          case 'suivi_motif':
            return this.compare(a.suivi_motif, b.suivi_motif, isAsc);
          case 'suivi_jours_restants':
            return this.compare(a.suivi_jours_restants, b.suivi_jours_restants, isAsc);
          case 'rg_count':
            return this.compare(a.rg_count, b.rg_count, isAsc);
          case 'er_count':
            return this.compare(a.er_count, b.er_count, isAsc);
          case 'anomalies_count':
            return this.compare(a.anomalies_count, b.anomalies_count, isAsc);
          default:
            return 0;
        }
      });
    }
    
    compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }


}
